import { metrics } from '../metrics';

const sendMetricsHandler = ({
  req = {},
  res = {},
  startTime,
  endpointName,
}) => {
  const duration = Date.now() - startTime;
  const { method = 'get' } = req;
  const { status } = res;

  metrics.httpRequestTiming({
    method,
    status,
    duration,
    endpointName,
    isUpstream: true,
  });
};

export const superagentRequestMetrics = ({ endpointName } = {}) => {
  return (req) => {
    const startTime = Date.now();

    req.on('response', (res) => {
      sendMetricsHandler({ req, res, startTime, endpointName });
    });

    req.on('error', (err) => {
      if (!err.response) {
        sendMetricsHandler({ req, startTime, endpointName });
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/middleware/superagent.js